/** Production origin of the lumi-next app (account.lumi-app.co). */
export const LUMI_NEXT_BASE_URL = 'https://account.lumi-app.co';

// Source paths in lumi-web-app. Kept as local literals (rather than importing
// RoutePaths from 'common-types') so this module stays dependency-free and
// unit-testable in a node environment. Mirror of RoutePaths.UNSUBSCRIBE and
// RoutePaths.SUBSCRIPTION_INFO.
const SOURCE_UNSUBSCRIBE = '/unsubscribe';
const SOURCE_SUBSCRIPTION = '/subscription';

/**
 * Maps a lumi-web-app pathname to the corresponding lumi-next path
 * (leading-slash form). Returns '/' for the root/base scenario.
 *
 * IMPORTANT: no locale prefix is added. lumi-next owns locale resolution — its
 * next-intl middleware prepends the locale and detects the user's language via
 * the Accept-Language header. Sending an already-prefixed path (e.g. /en) made
 * lumi-next prefix it again (→ /en/en) and 404. Send bare paths only.
 */
export const mapPathToLumiNextPath = (pathname: string): string => {
  const normalized = pathname.replace(/\/+$/, '') || '/';

  switch (normalized) {
    case SOURCE_UNSUBSCRIBE:
      return '/unsubscribe';
    case SOURCE_SUBSCRIPTION:
      return '/profile/manage-membership';
    default:
      // sign-in and every other route fall back to the lumi-next root.
      return '/';
  }
};

type TBuildLumiNextUrlParams = {
  pathname: string;
  userId?: string | null;
};

/**
 * Builds the absolute lumi-next URL to redirect to: the mapped bare path plus
 * an optional ?userid= query param for auto-login. No locale prefix — lumi-next
 * resolves the locale itself.
 */
export const buildLumiNextUrl = ({ pathname, userId }: TBuildLumiNextUrlParams): string => {
  const url = `${LUMI_NEXT_BASE_URL}${mapPathToLumiNextPath(pathname)}`;

  return userId ? `${url}?userid=${encodeURIComponent(userId)}` : url;
};
